import type { OtherProject } from "../../types/project";

interface OtherProjectRowProps {
  project: OtherProject;
}

function OtherProjectRow({ project }: OtherProjectRowProps) {
  const title = project.url ? (
    <a href={project.url} target="_blank" rel="noreferrer">
      {project.title}
    </a>
  ) : (
    project.title
  );

  return (
    <div className="other-item">
      <div>
        <h3>{title}</h3>
        <p>{project.description}</p>
      </div>
      <span className="other-tags">{project.tags.join(" · ")}</span>
    </div>
  );
}

export default OtherProjectRow;
